module.exports = __webpack_public_path__ + "static/media/thumbs_up.ca482e79.webp";